import { SocialsProvider } from '../../../../enums';

import FacebookIcon from './images/facebook.svg';
import InstagramIcon from './images/instagram.svg';
import LinkedinIcon from './images/linkedin.svg';
import { SocialsConfig } from './socialsLinks.types';

export const socialsConfig: SocialsConfig = {
  [SocialsProvider.Instagram]: { file: InstagramIcon, alt: 'instagram', label: 'Instagram' },
  [SocialsProvider.Facebook]: { file: FacebookIcon, alt: 'facebook', label: 'Facebook' },
  [SocialsProvider.Linkedin]: { file: LinkedinIcon, alt: 'linkedin', label: 'Linkedin' },
};
